import { QueryStringManager } from "@green24/npm-javascript-utils";

export const E_BoxRoute_Action = {
	FIRST_OPENING: "FIRST_OPENING",
	OPEN: "OPEN",
	RETRIEVE: "RETRIEVE",
}

/**
 * @readonly
 * @enum {String}
 */
export const E_Route = {
	BASE: '/',
	HELP: `/help`,
	CONFIGURATION: "/configuration",
	RENT_WIZARD: (section = ":section?") => `/rent-wizard/${section}`,
	OPEN_BOX: `/open-box`,
	//action = "RETRIEVE"|"OPEN"
	OPEN_BOX_PIN: (action = ":action") => `/open-box/` + action,
	BOX_OPENING: (action = ":action", queryData) => `${E_Route.OPEN_BOX_PIN(action)}/opening${queryData ? new QueryStringManager(queryData).toValidDataString() : ''}`,
	BOX_RENT_OVERTIME: (action = ":action", queryData) => `${E_Route.OPEN_BOX_PIN(action)}/overtime${queryData ? new QueryStringManager(queryData).toValidDataString() : ''}`,
	TERMS: `/terms`,
	DELIVERY_WIZARD: (section = ":section?") => `/delivery-wizard/${section}`
};
